import {CardContent, CardHeader, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {InstagramEmbed} from "react-social-media-embed";
import Alert from "@mui/material/Alert";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {venueMap} from "../shared/venue.ts";
import {BackButton} from "./BackButton.jsx";

const desc = "More info on the holiday 2-steppin for Christmas Eve, Christmas and New Years Eve";
const title = "Holiday 2-steppin";

export class Event {
    constructor(date, venueKey, insta, cover) {
        Object.assign(this, {
            date: date,
            venueKey: venueKey,
            insta: insta,
            cover: cover
        })
    }
}


const days = {
    "2024-12-24": "Christmas Eve",
    "2024-12-25": "Christmas Day",
    "2024-12-31": "New Year's Eve"
}

const closures = {
    "2024-12-24": ["atx-abgb", "atx-broken-spoke", "atx-continental-club", "atx-cotton-country-club", "atx-coupland", "atx-donns-depot","atx-little-longhorn"],
    "2024-12-25": ["atx-abgb", "atx-broken-spoke", "atx-cotton-country-club", "atx-donns-depot", "atx-duetts", "atx-gueros", "atx-little-longhorn", "atx-luckenbach", "atx-mercer", "atx-sagebrush", "atx-whitehorse"]
}

const dayKeys = Object.keys(days);

export const HolidayGuide = (props) => {


    const style = (window.innerWidth < 500) ? {position: "absolute",  left: -22, width: "100vw"} : {}

    return <Grid container spacing={1}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <meta property="og:description" content={desc}/>
                    <meta property="twitter:title" content={title}/>
                    <meta property="twitter:description" content={desc}/>
                    <title>{title}</title>
                    <meta property="description" content={desc} />
                    <link rel="canonical" href="https://austin2step.com/holiday-2-steppin"/>
                </Helmet>
                <Grid item xs={12}>
                    <BackButton />
                </Grid>

                        <CardHeader title={title} />
            
                <Grid item xs={12}>
                    <Alert severity="info" >
                        <Typography variant="body1">
                            Here's a quick guide to holiday 2-steppin' in Austin for Christmas Eve, Christmas Day and New Year's Eve. 
                        </Typography>
                    </Alert>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        New Year's Eve
                    </Typography> 
                </Grid>
                </Grid>


}